import { ExclamationTriangleIcon } from "@heroicons/react/16/solid";

export default function Banner(
    {title,
    content}

) {

  return (
    <div className="border rounded-customBorderRadius">
        <div className="flex rounded-t-customBorderRadius bg-red-600 p-3">
            <ExclamationTriangleIcon className="h-[20px] text-white mr-2"/>
          <p className="text-sm leading-6 text-white">
              {title}
          </p>
        </div>
        <div className="p-3">
            <p>{content}</p>
        </div>
    </div>
      )
}
